import * as React from 'react';
import type { SVGProps } from 'react';
import type { IconProps, ForwardedIconComponent } from './types';
const GridFilled = (React.forwardRef<SVGSVGElement, SVGProps<SVGSVGElement> & IconProps>(function GridFilled({
  title = 'Grid',
  titleId,
  size = '1em',
  ...props
}, ref) {
  return <svg width={size} height={size} viewBox="0 0 24 24" fill="none" ref={ref} aria-labelledby={titleId} {...props}>
        {title === undefined ? <title id={titleId}>{'Grid'}</title> : title ? <title id={titleId}>{title}</title> : null}
        <path d="M1 1v21h22V1H1Zm3 9h6.5v3H4v-3Zm9.5 0H20v3h-6.5v-3ZM20 7h-6.5V4H20v3Zm-9.5-3v3H4V4h6.5ZM4 16h6.5v3H4v-3Zm9.5 3v-3H20v3h-6.5Z" fill="currentColor" />
      </svg>;
}) as ForwardedIconComponent);
export default GridFilled;